module.exports = __webpack_public_path__ + "img/ltkover40-3x.ebcb02e.jpg";